import { Grid, Typography } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../../../../theme"

export function BSBimModelListHeader(): React.JSX.Element {
  return (
    <Grid item container xs={12} py={1}>
      <Grid item xs={4}>
        <Typography variant="subtitle2" fontSize={12} sx={{ color: customPalette.subtitleGray }}>
          Nom du fichier
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="subtitle2" fontSize={12} sx={{ color: customPalette.subtitleGray }}>
          Mise à jour le
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="subtitle2" fontSize={12} sx={{ color: customPalette.subtitleGray }}>
          Surface de plancher (m²)
        </Typography>
      </Grid>

      <Grid item xs={2}>
        <Typography variant="subtitle2" fontSize={12} sx={{ color: customPalette.subtitleGray }}>
          Estimations liées
        </Typography>
      </Grid>
      {/*<Grid item xs={2}>*/}
      {/*  <Typography variant="subtitle2" fontSize={12} sx={{ color: customPalette.subtitleGray }}>*/}
      {/*    Points d’attention*/}
      {/*  </Typography>*/}
      {/*</Grid>*/}
      <Grid item xs={1} />
    </Grid>
  )
}
